import { Box } from '@mui/material';

export default function CardContent({ children, locked }: CardContentProps) {

    const sx = locked ? {
        opacity: 0.25,
        pointerEvents: 'none',
    } : undefined;

    return <Box sx={sx}>
        {children}
    </Box>;

}